import { useState } from 'react';

import { useIsMobile } from '../hooks/useMediaQuery';

import { Button } from './Button';
import s from './DesktopToolNote.module.css';
import { StatusBanner } from './StatusBanner';

const STORAGE_PREFIX = 'desktop-note:';

function isAcknowledged(id: string): boolean {
  try {
    return sessionStorage.getItem(STORAGE_PREFIX + id) === '1';
  } catch {
    return false;
  }
}

function acknowledge(id: string): void {
  try {
    sessionStorage.setItem(STORAGE_PREFIX + id, '1');
  } catch {
    /* storage unavailable — the note simply returns next time */
  }
}

/**
 * For the handful of tools that are honestly desktop-shaped — the PDF review
 * workbench, the kanban board, the attendance month grid. They still open on a
 * phone; this just says so once, per tool, per tab. Renders nothing on a
 * desktop viewport.
 */
export function DesktopToolNote({ id }: { id: string }): JSX.Element | null {
  const isMobile = useIsMobile();
  const [dismissed, setDismissed] = useState(() => isAcknowledged(id));
  if (!isMobile || dismissed) return null;
  return (
    <StatusBanner tone="info" className={s.root ?? ''}>
      <span className={s.text}>This tool works best on a larger screen.</span>
      <Button
        variant="ghost"
        size="sm"
        className={s.button}
        onClick={() => {
          acknowledge(id);
          setDismissed(true);
        }}
      >
        Got it
      </Button>
    </StatusBanner>
  );
}
